import { PageHeaderLayout, Switch } from "@homebound/beam";
import { useToggle } from "src/hooks";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useStripStage } from "src/hooks/useStripStage";
import { useProjectContext } from "src/routes/projects/context/ProjectContext";
import { ProjectParams } from "src/routes/routesDef";
import { HomeownerContractsTable } from "./components/HomeownerContractsTable";

export function HomeownerContractsPage() {
  useStripStage();
  const { projectId } = useRouteParams<ProjectParams>();
  const { __typename, clientContract, name } = useProjectContext();
  const [showSharedCosts, toggleSharedCosts] = useToggle(false);

  return (
    <PageHeaderLayout
      pageHeader={{
        title: __typename === "StandaloneProject" ? `${clientContract}s` : "Client Contracts",
        documentTitleSuffix: name,
        rightSlot: <Switch label="Show Shared Costs" compact selected={showSharedCosts} onChange={toggleSharedCosts} />,
      }}
    >
      <HomeownerContractsTable projectId={projectId} showSharedCosts={showSharedCosts} />
    </PageHeaderLayout>
  );
}
